import {useAppSelector} from "./store";
import {OverlayState} from "../store/overlay";

export const useOverlayState = () => {
  return useAppSelector<OverlayState>(state => state.overlay).active;
};